<template>
  <div class="header">
    <div class="header-content">
      <router-link to="/">
        <img class="header-image" src="../assets/seltzer.png" alt="" />
      </router-link>
      <router-link to="/impressum"
        ><div class="menu-point">Kontakt/Impressum</div></router-link
      >
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {};
  },
  methods: {}
};
</script>
